import dayjs from 'dayjs'
import weekOfYear from 'dayjs/plugin/weekOfYear'
import isoWeek from 'dayjs/plugin/isoWeek'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import weekday from 'dayjs/plugin/weekday'
import updateLocale from 'dayjs/plugin/updateLocale'
import minMax from 'dayjs/plugin/minMax'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(isSameOrAfter)
dayjs.extend(updateLocale)
dayjs.extend(customParseFormat)
dayjs.extend(minMax)
dayjs.extend(weekday)
dayjs.extend(weekOfYear)
dayjs.extend(isoWeek)
dayjs.extend(utc)
dayjs.extend(timezone)

export const getDateRange = (start, end = dayjs()) => {
  const result = []
  for (
    let currentDate = dayjs(end);
    currentDate.isSameOrAfter(start, 'day');
    currentDate = currentDate.subtract(1, 'day')
  ) {
    result.push(Number(currentDate.format('YYYYMMDD')))
  }
  return result
}

export const getWeek = (data) => {
  const index = data ? dayjs(`${data}`, 'YYYYMMDD').day() : 8
  const mappings = ['日', '一', '二', '三', '四', '五', '六', '？？']
  return [index, mappings[index]]
}

/** 按周起始对齐，划到 ISO 周 id；endInclusive 传时与选区一致，否则到昨天 */
export const getWeekRange = (openTime, weekStart = 5, endInclusive) => {
  const weeks = {}
  let startDate = openTime.day(weekStart)
  const rangeEndExclusive =
    endInclusive !== undefined && endInclusive !== null
      ? dayjs(String(endInclusive), 'YYYYMMDD').add(1, 'day').startOf('day')
      : dayjs().subtract(1, 'day').startOf('day')

  const generateWeekId = (date) => {
    const year = date.isoWeekYear()
    const week = date.isoWeek()
    return year * 100 + week
  }

  const addDayToWeek = (weekId, date) => {
    const numberCurrentDate = Number(date.format('YYYYMMDD'))
    if (weeks[weekId]) {
      weeks[weekId].days.push(numberCurrentDate)
    } else {
      weeks[weekId] = { id: weekId, days: [numberCurrentDate] }
    }
  }

  while (startDate.isBefore(rangeEndExclusive)) {
    const weekId = generateWeekId(startDate)
    for (let j = 0; j < 7; j++) {
      if (startDate.isSameOrAfter(rangeEndExclusive)) {
        break
      }
      addDayToWeek(weekId, startDate)
      startDate = startDate.add(1, 'day')
    }
  }

  return Object.values(weeks).sort((a, b) => b.id - a.id)
}

/**
 * 获取当前北京时间
 */
export const getBeijingTime = () => {
  return dayjs().tz('Asia/Shanghai')
}

/**
 * 判断某个日期（YYYYMMDD格式）的数据是否完整
 * @param date 日期，格式为 YYYYMMDD 的数字
 * @param isRoasData 是否为ROAS数据，ROAS数据需要下午5点才完整，其他数据下午4点完整
 * @returns true表示数据完整，false表示数据不完整
 */
export const isDateDataComplete = (date, isRoasData = false) => {
  const beijingTime = getBeijingTime()
  const beijingHour = beijingTime.hour()
  const beijingDate = beijingTime.format('YYYYMMDD')
  const targetDate = date.toString()

  // 如果目标日期是今天，数据肯定不完整
  if (targetDate === beijingDate) {
    return false
  }

  // 如果目标日期是昨天
  const yesterday = beijingTime.subtract(1, 'day').format('YYYYMMDD')
  if (targetDate === yesterday) {
    // ROAS数据需要下午5点才完整，其他数据下午4点完整
    const completeHour = isRoasData ? 17 : 16
    return beijingHour >= completeHour
  }

  // 如果目标日期早于昨天，数据应该是完整的
  if (targetDate < yesterday) {
    return true
  }

  // 如果目标日期晚于昨天，数据不完整
  return false
}

/**
 * 获取完整数据的截止日期（YYYYMMDD格式）
 * @param isRoasData 是否为ROAS数据
 * @returns 最后一个完整数据的日期
 */
export const getLastCompleteDate = (isRoasData = false) => {
  const beijingTime = getBeijingTime()
  const beijingHour = beijingTime.hour()
  const completeHour = isRoasData ? 17 : 16

  // 如果当前时间已经过了完整时间点，昨天的数据是完整的
  if (beijingHour >= completeHour) {
    return Number(beijingTime.subtract(1, 'day').format('YYYYMMDD'))
  }

  // 否则，前天的数据是完整的
  return Number(beijingTime.subtract(2, 'day').format('YYYYMMDD'))
}
